var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.327148,
    y: 0.0803223,
    width: 28,
    height: 28,
    rx: 4,
    fill: "#71C6FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9272 10.4798V14.9798C17.9272 15.6958 18.2116 16.3826 18.718 16.8889C19.2243 17.3953 19.9111 17.6798 20.6272 17.6798C21.3432 17.6798 22.03 17.3953 22.5363 16.8889C23.0427 16.3826 23.3271 15.6958 23.3271 14.9798V14.0798C23.327 12.0485 22.6398 10.077 21.3771 8.48584C20.1144 6.89469 18.3506 5.77747 16.3725 5.31583C14.3944 4.8542 12.3183 5.0753 10.4818 5.94319C8.64524 6.81109 7.15631 8.27472 6.25709 10.0961C5.35786 11.9175 5.10123 13.9895 5.52891 15.9753C5.95659 17.961 7.04343 19.7437 8.61272 21.0334C10.182 22.3231 12.1414 23.0441 14.1724 23.079C16.2034 23.1139 18.1864 22.4608 19.7992 21.2258M17.9272 14.0798C17.9272 16.068 16.3154 17.6798 14.3272 17.6798C12.3389 17.6798 10.7272 16.068 10.7272 14.0798C10.7272 12.0915 12.3389 10.4798 14.3272 10.4798C16.3154 10.4798 17.9272 12.0915 17.9272 14.0798Z",
    stroke: "#1E1E1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.1c471815e4df92f00505d2e3a84893e6.svg";
export { ForwardRef as ReactComponent };